var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMessageInPrivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 15.0099H21V21H13.8V15.0099Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4 11.4158C16.7635 11.4158 16.153 11.6682 15.7029 12.1176C15.2529 12.5669 15 13.1764 15 13.8118V15.0099H19.8V13.8118C19.8 13.1764 19.5471 12.5669 19.0971 12.1176C18.647 11.6682 18.0365 11.4158 17.4 11.4158Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3995 17.7286C17.3402 17.7286 17.2823 17.7461 17.2331 17.7791C17.1838 17.812 17.1454 17.8587 17.1228 17.9135C17.1001 17.9682 17.0942 18.0284 17.1057 18.0865C17.1173 18.1446 17.1458 18.198 17.1877 18.2399C17.2296 18.2818 17.283 18.3103 17.3411 18.3218C17.3992 18.3334 17.4594 18.3275 17.5141 18.3048C17.5688 18.2821 17.6156 18.2437 17.6485 18.1945C17.6814 18.1452 17.699 18.0873 17.699 18.0281C17.699 17.9486 17.6674 17.8725 17.6113 17.8163C17.5551 17.7601 17.4789 17.7286 17.3995 17.7286",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10.8503C20.9168 9.57663 20.5439 8.33868 19.9096 7.23051C19.2753 6.12235 18.3962 5.17314 17.3393 4.45503C16.2824 3.73692 15.0754 3.26882 13.8101 3.0863C12.5448 2.90378 11.2545 3.01164 10.0372 3.4017C8.81989 3.79176 7.70769 4.45374 6.78512 5.33732C5.86254 6.22091 5.15388 7.30285 4.71298 8.5009C4.27209 9.69895 4.11057 10.9816 4.24071 12.2513C4.37084 13.521 4.78921 14.7444 5.464 15.8285L3 21L8.1768 18.5368C9.14753 19.1412 10.2319 19.5408 11.3632 19.7109",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessageInPrivate);
export default __webpack_public_path__ + "static/media/send-message-in-private.2c21b04ae5d9f2d1d6113b94cbd9fa62.svg";
export { ForwardRef as ReactComponent };